<template>
  <div class="markup">
    <div class="markup__subtitle markup__subtitle_head">ТТ Формат In-Read Max</div>
    <div class="markup__h markup__h_3">
      Данное размещение содержит - лого и текст, кнопку для перехода, видео и изображение.
    </div>

    <div class="attention attention_info">
      <div class="attention__title">Важно знать:</div>
        <p>1. Изображения пролистываются автоматически, или их можно пролистать вручную</p>
        <p>2. Рекомендуем избегать дублирования нескольких элементов в ролике и изображениях, чтобы визуально формат выглядел гармонично</p>
    </div>
    <br>

    <div class="markup__h markup__h_2">
      <strong>Необходимые материалы для размещения:</strong>
    </div>
    <ul class="markup__ul markup__ul_nested">
      <li>
        <div class="markup__h markup__h_3">
          <strong>Видеоролик:</strong>
        </div>
        <ul class="markup__ul markup__ul_nested">
          <li>Формат: MP4</li>
          <li>Видеокодек: H.264</li>
          <li>Аудиокодек: MP3 или AAC</li>
          <li>Разрешение: рекомендуется не ниже Full HD 1080p</li>
          <li>Частота кадров: 30 в секунду</li>
          <li>Соотношение сторон: естественное, без добавления черного поля сверху и снизу (например, 16:9)</li>
          <li>Вес: рекомендуется до 3 МБ</li>
          <li>
            Хронометраж:
            <ul class="markup__ul markup__ul_nested">
              <li>оптимальный: 10-15 секунд</li>
              <li>максимальный: 30 секунд</li>
            </ul>
          </li>
        </ul>
      </li>
      <li>
        <div class="markup__h markup__h_3">
          <strong>Изображения:</strong>
        </div>
        <ul class="markup__ul markup__ul_nested">
          <li>Соотношение сторон: 16:9</li>
          <li>
            Размеры: ширина не менее 1000px
            <div class="attention attention_warn">
              <div class="attention__title">Важно знать:</div>
                <p>Изображение будет слегка затемнено, чтобы видео не сливалось с изображением</p>
            </div>
          </li>
        </ul>
      </li>
      <li>
        <div class="markup__h markup__h_3">
          <strong>Логотип:</strong>
        </div>
        <ul class="markup__ul markup__ul_nested">
          <li>Формат: PNG</li>
          <li>Прозрачный фон</li>
          <li>Соотношение сторон: рекомендуется 1:1</li>
          <li>Размеры: рекомендуется ширина 200px</li>
        </ul>
      </li>
      <li>
        <div class="markup__h markup__h_3">
          <strong>Текст (с учетом пробелов):</strong>
        </div>
        <ul class="markup__ul markup__ul_nested">
          <li>Заголовок: до 40 символов</li>
          <li>Описание: до 75 символов</li>
          <li>Для мобильного размещения рекомендуется ограничиться только заголовком.</li>
        </ul>
        <div class="html2pdf__page-break"/>
      </li>
      <li>
        <div class="markup__h markup__h_3">
          <strong>Кнопка:</strong>
        </div>
        <ul class="markup__ul markup__ul_nested">
          <li>Текст desktop (с учетом пробелов): рекомендуется – до 15 символов, максимум – 30 символов</li>
          <li>Текст mobile (с учетом пробелов): максимум – 15 символов</li>
          <li>Цвет: рекомендуется использовать основной цвет бренда (RGB, HEX)</li>
        </ul>
      </li>
    </ul>

    <marked-zone-atention></marked-zone-atention>
  </div>
</template>

<script>
import markedZoneAtention from '@/components/documentation/markedZoneAtention.vue';

export default {
  name: 'inreadMax',
  components: {
    markedZoneAtention,
  },
  data() {
    return {};
  },
};
</script>

<style scoped lang='stylus'>
@import '../../../styles/main.styl'
@import '../../../styles/documentation_article_markup.styl'

</style>
